import { useState, ReactNode } from 'react'
import { useReactiveVar } from '@apollo/client'
import FilterAltIcon from '@mui/icons-material/FilterAlt'
import FilterAltOffIcon from '@mui/icons-material/FilterAltOff'
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown'
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp'
import { Button, Card, CardActions, CardContent, CardHeader } from '@mui/material'
import { Box } from '@mui/system'
import { Loader } from 'components'
import { condensedEventCardsVar } from 'context'
import { EventFilters } from './EventFilters'

export interface IEventsProps {
  height?: string
  loading: boolean
  children: ReactNode
  showToggleCollapseButton?: boolean
  headerActionComponents?: ReactNode | ReactNode[]
}

export const Events = ({
  children,
  height = '100%',
  loading,
  showToggleCollapseButton,
  headerActionComponents
}: IEventsProps) => {
  const [showFilters, setShowFilters] = useState(false)
  const condensed = useReactiveVar(condensedEventCardsVar)

  const filterActionButton = (
    <Box sx={{ paddingRight: 1 }}>
      <Button onClick={() => setShowFilters(!showFilters)} size="small">
        {showFilters ? <FilterAltOffIcon color="success" /> : <FilterAltIcon color="success" />}
      </Button>
    </Box>
  )

  const handleCollapseToggleClick = () => {
    condensedEventCardsVar(!condensed)
  }

  const toggleCollapse = showToggleCollapseButton && (
    <Box>
      <Button
        color="success"
        onClick={handleCollapseToggleClick}
        startIcon={condensed ? <KeyboardArrowDownIcon /> : <KeyboardArrowUpIcon />}
      >
        {condensed ? 'Expand All' : 'Collapse All'}
      </Button>
    </Box>
  )

  const headerActions = (
    <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
      {headerActionComponents}
      {toggleCollapse}
      {filterActionButton}
    </Box>
  )

  return (
    <Card
      sx={{
        height,
        display: 'flex',
        flexDirection: 'column'
      }}
    >
      <CardHeader action={headerActions} title="Events" disableTypography />
      <CardActions>{showFilters ? <EventFilters /> : null}</CardActions>
      <CardContent
        sx={{
          padding: 1,
          height: '100%',
          display: 'flex',
          flexDirection: 'column'
        }}
      >
        {loading ? <Loader /> : children}
      </CardContent>
    </Card>
  )
}
